import script from "./MessageRecordFocus.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageRecordFocus.vue?vue&type=script&setup=true&lang=ts"

import "./MessageRecordFocus.vue?vue&type=style&index=0&id=7cebe298&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cebe298"]])

export default __exports__